import React from 'react';
import { injectIntl } from 'react-intl';
import RadioButtonLabel from '../../molecules/labels/RadioButtonLabel';
import Span from '../../atoms/spans/Span';
import Paragraph from '../../atoms/paragraphs/Paragraph';
import { Tooltip } from 'react-tooltip';

/**
 * CycleSelector component for selecting subscription plans
 * @param {object} props - React props object
 * @returns {React.ReactElement} PlanSelector component
 */
const CycleSelector = ({ intl, ...props }) => {
  const { cycles, currentCycle, selectedCycle, onChange, className, plan } =
    props;

  return (
    <div className={`cycle-selector ${className || ''}`}>
      {cycles.map((cycle, index) => (
        <React.Fragment key={cycle.id}>
          <div
            className={`cycle-option ${cycle.id} position-relative`}
            data-tooltip-id={
              cycle.disabled || plan[cycle.id + '_disabled']
                ? 'disabledCycle_' + cycle.id
                : ''
            }
            data-tooltip-delay-hide={250}
          >
            {(currentCycle === cycle.id && (
              <div
                className={`current-cycle-label ${
                  cycle.discount && plan && plan[cycle.id + '_discount'] !== 0
                    ? 'discount'
                    : ''
                }`}
              >
                <Paragraph className='text-paragraph bold text-primary m-0'>
                  {intl.messages['currentCycleFlag']}
                </Paragraph>
              </div>
            )) || <></>}

            <div className='cycle-option-inner-wrapper d-flex flex-row align-items-center'>
              <RadioButtonLabel
                id={cycle.id}
                className='checkbox round cycle-radio'
                name='subscription-cycle'
                checked={selectedCycle === cycle.id}
                onChange={() => onChange(cycle.id)}
                value={cycle.id}
                disabled={cycle.disabled || plan[cycle.id + '_disabled']}
              ></RadioButtonLabel>
              <div
                className={`cycle-label ${
                  cycle.discount &&
                  plan &&
                  plan[cycle.id + '_discount'] !== undefined &&
                  plan[cycle.id + '_discount'] !== 0
                    ? 'discount'
                    : ''
                }`}
              >
                <Span className='cycle-name'>
                  {intl.messages['paymentCycle_' + cycle.id]}
                </Span>
                {cycle.discount &&
                  plan &&
                  plan[cycle.id + '_discount'] !== undefined &&
                  plan[cycle.id + '_discount'] !== 0 && (
                    <Span className='cycle-discount'>
                      (
                      {(
                        ((plan.month - plan[cycle.id]) / plan.month) *
                        100
                      ).toFixed(0)}
                      % {intl.messages['cycleDiscount']})
                    </Span>
                  )}
              </div>
            </div>
          </div>

          {(index < cycles.length - 1 && (
            <div className='cycle-divider'></div>
          )) || <></>}

          <Tooltip
            id={`disabledCycle_${cycle.id}`}
            className='tooltip'
            content={
              plan[cycle.id + '_disabled']
                ? intl.messages['disabledCycleTooltipPlan']
                : intl.messages['disabledCycleTooltipDowngrade']
            }
            place='bottom'
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default injectIntl(CycleSelector);
